import { useTheme } from "@mui/material/styles";
import Checkbox from "@mui/material/Checkbox";

import Box from "ui/atom/Box";


export default function CheckboxTile({ checked, onChange, children }) {
	const theme = useTheme();

 	const style = {
		root: {
			alignItems: "center",
			p: theme.spacing(1, 2, 1, 0.875),
			borderRadius: "12px",
			border: "2px solid #434579" /* todo: move to theme */
		},
		content: { alignItems: "center" },
		text: { alignItems: "flex-start", textAlign: "left" },
		button: { flex: "1 0 auto" }
	};

	return (
		<Box gap={1} sx={style.root}>
			<Checkbox checked={checked} onChange={onChange} color="tertiary" />
			<Box.Column sx={style.text}>
				{children}
			</Box.Column>
		</Box>
	);
}